import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-caption.css.lit';

/**
 * Caption component
 * @element pc-caption
 * @slot - This element has a default slot
 */
@customElement('pc-caption')
export class PCCaption extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html`<span class="caption"><slot></slot></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-caption': PCCaption;
  }
}
